import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`前言`}</h2>
    <p>{`一个人，可以走得很快。`}</p>
    <p>{`一人一剑，可以走得很远。`}</p>
    <p>{`一人一剑一套剑法，可以走得又快又远。`}</p>
    <p>{`如果说开发功底是一把剑，那开发技巧，算得上是优秀的剑招。`}</p>
    <p>{`诡谲多变，灵动自然的剑招组合，便是剑法。`}</p>
    <p>{`一剑出，剑动九天，长虹贯日。一剑落，轻云蔽月，飘然若雪。`}</p>
    <p>{`路人齐呼：" `}<strong parentName="p">{`技术活，该赏。`}</strong>{`"`}</p>
    <p>{`今天我们就来聊一下开发中的小tips,希望本文对你有所帮助。`}</p>
    <h2>{`非循环形式创建数组`}</h2>
    <p>{`习惯了循环填充，不妨试试迭代器。`}</p>
    <p>{`new Array().keys()方法会返回一个迭代器`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/68b848cfb66e48f88c752f2ccb620819~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <p>{`而这个小东西，刚好可以交给Array.from处理。`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/6ff43ec76a8a41a79741a66984e83785~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <p><strong parentName="p">{`不管绿茶配不配青梅，用习惯了，这就不会是头一回`}</strong>{`。`}</p>
    <p>{`这第一剑还不算完，Array.from有第二个参数,形似map。`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/06a1b9af8f3c434e9281ecb0c4bb88cb~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <h2>{`数组扁平化`}</h2>
    <p>{`当我的名字在你脑海中闪过，你最先想到的，是什么？`}</p>
    <p>{`"不好意思，不认识。"`}</p>
    <p>{`问题不大，我的内心毫无波动，甚至还有点想敲代码。`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/59188b1c09c54af9ac768fe20ead80a8~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <p>{`扁平化可算得上是面试中的网红题了，频率能与事件循环打印题一较高下。`}</p>
    <p>{`抛开原生的flat，还有循环/reduce/replace等诸多解决方案，本文只介绍一个。`}</p>
    <p>{`在不支持原生flat的情况下,toString+split就很棒了。`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/648962b536bd4e769cd4515e8241182b~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <h2>{`溯源测试`}</h2>
    <p>{`修炼一途，乃窃阴阳，夺造化，转涅盘，握生死，掌轮回...`}</p>
    <p>{`咳咳，不好意思，走错片场了。`}</p>
    <p>{`剑招的强弱也需气运加持，最好的气运自然是在自己领域。`}</p>
    <p>{`当我们想去测试某个库api的具体使用，但又不想在本地单独搞一套时，直接去对应网站即可。`}</p>
    <p>{`以`}<a parentName="p" {...{
        "href": "https://momentjs.com/"
      }}>{`moment`}</a>{`为例，打开官网，调出开发者工具--控制台。`}</p>
    <p>{`直接写想测试的api即可：`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/78b8462bf4364668b1ecc8776bb7db20~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <p>{`如果想在自己网站测，可通过创建script+指定src+appendChild形式实现`}</p>
    <p>{`推荐一波`}<a parentName="p" {...{
        "href": "https://www.bootcdn.cn/"
      }}>{`bootcdn`}</a>{`，很多`}<strong parentName="p">{`你想找的开发相关链接`}</strong>{`都可以找到。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var s=document.createElement('script')
s.src='https://cdn.bootcdn.net/ajax/libs/axios/0.21.1/axios.js'
document.body.appendChild(s)
`}</code></pre>
    <h2>{`replay xhr`}</h2>
    <p>{`大概没有什么比一剑落空更让人无奈的事了吧。`}</p>
    <p>{`一次页面重刷就意味着一次蓄力等待，进攻太慢。`}</p>
    <p>{`好在开发者工具提供了replay xhr，选中要重新请求的接口，右击replay xhr即可。`}</p>
    <p><img parentName="p" {...{
        "src": "https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/1901742f86e64c8a80131a340ca407ae~tplv-k3u1fbpfcp-zoom-1.image",
        "alt": null
      }}></img></p>
    <h2>{`再会`}</h2>
    <p>{`情如风雪无常,`}</p>
    <p>{`却是一动即殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>
    <h2>{`相关链接`}</h2>
    <ul>
      <li parentName="ul">{`moment : `}<a parentName="li" {...{
          "href": "https://momentjs.com/"
        }}>{`https://momentjs.com/`}</a></li>
      <li parentName="ul">{`bootcdn: `}<a parentName="li" {...{
          "href": "https://www.bootcdn.cn/"
        }}>{`https://www.bootcdn.cn/`}</a></li>
      <li parentName="ul">{`flat: `}<a parentName="li" {...{
          "href": "https://lengyuexin.github.io/gatsby/js-core/flat/"
        }}>{`https://lengyuexin.github.io/gatsby/js-core/flat/`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      